import { useState } from "react";
import { motion } from "framer-motion";
import { Mail, ArrowRight } from "lucide-react";
import { submitLead } from "@/lib/api";
import { useSite, useImages } from "@/context/SiteContent";
import { CheckoutButton } from "./CheckoutButton";

const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

export const SampleLesson = () => {
  const { sample, lessons, price } = useSite();
  const images = useImages();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const lesson = lessons.find((l) => l.title.toLowerCase() === (sample.lessonTitle || "").toLowerCase()) || lessons[0];

  const submit = async (e) => {
    e.preventDefault();
    if (!emailOk(email.trim())) return setError("Please enter a valid email address.");
    setError(""); setState("busy");
    try { await submitLead({ type: "sample", email: email.trim(), name: name.trim() }); setState("done"); }
    catch { setState("idle"); setError("We could not send the lesson right now. Please try again shortly."); }
  };

  return (
    <section className="sample-section" id="sample" data-rail="Free lesson" data-testid="sample-section">
      <div className="container">
        <div className="sample-card reveal">
          <div className="sample-copy">
            <div className="eyebrow">{sample.eyebrow}</div>
            <h2>{sample.heading}</h2>
            <p className="lead">{sample.body}</p>
            {state === "done" ? (
              <motion.div className="sample-done" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} data-testid="sample-success">
                <span className="booking-success-icon">✓</span>
                <div>
                  <strong>Sent. Check your inbox.</strong>
                  <p>"{lesson?.title}" is on its way. When you are ready for all 52, the eBook is a one-time {price}.</p>
                  <CheckoutButton className="btn btn-gold" testId="sample-checkout-btn">Get the eBook • {price}</CheckoutButton>
                </div>
              </motion.div>
            ) : (
              <form className="sample-form" onSubmit={submit} noValidate data-testid="sample-form">
                <label className="form-field"><span>First name <em>Optional</em></span>
                  <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your first name" data-testid="sample-name-input" /></label>
                <label className="form-field"><span>Email address *</span>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid="sample-email-input" /></label>
                <div className="form-error" data-testid="sample-error">{error}</div>
                <button className="btn btn-gold" type="submit" disabled={state === "busy"} data-testid="sample-submit-btn"><Mail size={16} /> {state === "busy" ? "Sending..." : sample.cta}</button>
                <small className="sample-note">One email with the lesson. No spam, unsubscribe any time.</small>
              </form>
            )}
          </div>
          <div className="sample-preview" data-testid="sample-preview">
            <img className="sample-cover" src={images.cover} alt="" />
            <div className="sample-page">
              <small>{lesson?.category}</small>
              <h3>{lesson?.title}</h3>
              <p>{lesson?.text}</p>
              <div className="sample-blur">
                <span>Reflection question</span>
                <p>{lesson?.question}</p>
              </div>
              <div className="sample-unlock"><ArrowRight size={14} /> Full lesson and prompt arrive by email</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
